module.exports = __webpack_public_path__ + "static/media/go3.9c3a7fa2.jpg";